if (!customElements.get('article-toggle')) {
  class ArticleToggle extends HTMLElement {
    constructor() {
      super();

      this.handleClickRef = this.handleClick.bind(this);
    }

    handleClick(event) {
      if (event.target.tagName != 'A') return;
      if (event) event.preventDefault();

      fetch(event.target.getAttribute('href') + '?view=ajax')
        .then((res) => res.text())
        .then((data) => {
          document.dispatchEvent(
            new CustomEvent('article-modal:open', {
              detail: { innerHTML: data },
            }),
          );
        })
        .catch((err) => {
          window.location.href = event.target.getAttribute('href');
        });
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClickRef);
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClickRef);
    }
  }

  customElements.define('article-toggle', ArticleToggle);
}
